import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { HiStar } from 'react-icons/hi';
import { useTheme } from '../Flowbite/ThemeContext';
import { useRatingContext } from './RatingContext';
export var RatingStar = function RatingStar(_ref) {
  var _ref$filled = _ref.filled,
    filled = _ref$filled === void 0 ? true : _ref$filled,
    _ref$starIcon = _ref.starIcon,
    Icon = _ref$starIcon === void 0 ? HiStar : _ref$starIcon,
    className = _ref.className;
  var _useRatingContext = useRatingContext(),
    _useRatingContext$siz = _useRatingContext.size,
    size = _useRatingContext$siz === void 0 ? 'sm' : _useRatingContext$siz;
  var theme = useTheme().theme.rating.star;
  return _jsx(Icon, {
    className: classNames(theme.sizes[size], theme[filled ? 'filled' : 'empty'], className),
    "data-testid": "flowbite-rating-star"
  });
};